import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
} from "@fluentui/react-components";
import { useAuth } from "../auth/AuthContext";
import { useOrganization } from "../context/OrganizationContext";
import { useDashboardStyles } from "./Dashboard.styles";
import Loading from "../components/Loading";
import Header from "../components/Header";
import FundManagement from "../fund/FundManagement";
import CompanyManagement from "../company/CompanyManagement";
import MetricManagement from "../metric/MetricManagement";
import ReportManagement from "../report/ReportManagement";
import ScorecardManagement from "../scorecard/ScorecardManagement";
// import ReportMockComponent from "../reportMock/ReportMockComponent";

const Dashboard = () => {
  const { isAuthenticated, loading: authLoading } = useAuth();
  const { isOrganizationContextPending } = useOrganization();
  const navigate = useNavigate();
  const styles = useDashboardStyles();
  const [openItems, setOpenItems] = useState(["1"]);

  const handleToggle = (event, data) => {
    setOpenItems(data.openItems);
  };

  useEffect(() => {
    if (authLoading) {
      return;
    }

    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, authLoading, navigate]);

  if (authLoading || isOrganizationContextPending) {
    return <Loading message="Loading dashboard..." />;
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Header />

      <Card className={styles.card}>
        <Accordion openItems={openItems} onToggle={handleToggle} collapsible>
          <AccordionItem value="1">
            <AccordionHeader>Fund Management</AccordionHeader>
            <AccordionPanel>
              <FundManagement />
            </AccordionPanel>
          </AccordionItem>
          <AccordionItem value="2">
            <AccordionHeader>Company Management</AccordionHeader>
            <AccordionPanel>
              <CompanyManagement />
            </AccordionPanel>
          </AccordionItem>
          <AccordionItem value="3">
            <AccordionHeader>Metric Management</AccordionHeader>
            <AccordionPanel>
              <MetricManagement />
            </AccordionPanel>
          </AccordionItem>
          <AccordionItem value="4">
            <AccordionHeader>Report Management</AccordionHeader>
            <AccordionPanel>
              <ReportManagement />
            </AccordionPanel>
          </AccordionItem>
          <AccordionItem value="5">
            <AccordionHeader>Scorecard Management</AccordionHeader>
            <AccordionPanel>
              <ScorecardManagement />
            </AccordionPanel>
          </AccordionItem>
          {/* <AccordionItem value="5">
            <AccordionHeader>Report Mock</AccordionHeader>
            <AccordionPanel>
              <ReportMockComponent />
            </AccordionPanel>
          </AccordionItem> */}
        </Accordion>
      </Card>
    </div>
  );
};

export default Dashboard;
